<template>
  <div>
    <h2>Nastavení</h2>
    <div>
      <b-nav tabs>
        <b-nav-item
          v-for="(item, index) in settingItems"
          :key="index"
          :to="item.to">
          {{ item.name }}
        </b-nav-item>
      </b-nav>
    </div>
    <div class="p-3">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SettingsItemsMixin from '@/components/navigation/top-navigation/SettingsItemsMixin';

export default {
  name: 'Settings',
  mixins: [
    SettingsItemsMixin,
  ],
  computed: {
    ...mapGetters([
    ]),
  },
};
</script>

<style scoped>

</style>
